import { render, staticRenderFns } from "./visitorRecord.vue?vue&type=template&id=315b7798&scoped=true&"
import script from "./visitorRecord.vue?vue&type=script&lang=js&"
export * from "./visitorRecord.vue?vue&type=script&lang=js&"
import style0 from "./visitorRecord.vue?vue&type=style&index=0&id=315b7798&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315b7798",
  null
  
)

export default component.exports